import {
  UsersStatisticsState,
  REQUEST_USERSTATISTICS,
  REQUEST_USERSTATISTICS_DONE
} from "./types";

const initialState: UsersStatisticsState = {
  isLoading: true,
  userStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_USERSTATISTICS:
      return {
        isLoading: true,
        userStatistics: action.payload
      };
    case REQUEST_USERSTATISTICS_DONE:
      return {
        isLoading: false,
        userStatistics: action.payload
      };
    default:
      return state;
  }
}
